/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Error_Preview_Request_InvalidInputs */

const vi_einvoice_error_preview_request_invalid = /** @type {(inputs: Einvoice_Error_Preview_Request_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể tạo yêu cầu tải bản xem trước hóa đơn. Vui lòng thử lại sau.`)
};

/**

* @param {Einvoice_Error_Preview_Request_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_error_preview_request_invalid = /** @type {((inputs?: Einvoice_Error_Preview_Request_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Error_Preview_Request_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_error_preview_request_invalid(inputs)
});